import { UseMainUIFeatureSettings } from '../types';

import { useAchievementsAdminPageSettings } from './achievement';
import { useArticlePageSettings, useArticlePublisherSettings } from './article';
import { useAskMeAnythingEventCreationPageSettings, useAskMeAnythingEventEditingPageSettings } from './askMeAnything';
import { useCampaignsDashboardPageSettings } from './campaign';
import { useHomeFeedPageSettings, useThreadPageSettings } from './feed';
import { useDiscoverGroupsPageSettings } from './group';
import { useInboxPageSettings } from './inbox';
import {
  useInsightsAdminPageSettings,
  useInsightsCampaignPageSettings,
  useInsightsLeadersMyInsightsPageSettings,
  useInsightsLeadersOrgPageSettings,
  useInsightsNavigationSettings,
  useInsightsNetworkPageSettings,
  useInsightsQnAMyInsightsPageSettings,
  useInsightsQnAOrgPageSettings,
} from './insights';
import { useLeadersAdminPageSettings, useLeadershipCornerAdminPageSettings } from './leader';
import { useConfigureTenantAdminPageSettings, useNetworkAdminPageSettings } from './legacy';
import { useComplianceDataAdminPageSettings } from './manageData';
import { useNavigationSettings } from './navigation';
import { useDraftPostSettings } from './publisher';
import { useQuestionsAdminPageSettings } from './question';
import { useStorylineAdminPageSettings } from './storyline';
import { useStrictFeatureSettings } from './useStrictFeatureSettings';
import { useUserRolesAdminPageSettings } from './user';

export const useMainFeatureSettings: UseMainUIFeatureSettings = (...args) => {
  const achievementsAdminPage = useAchievementsAdminPageSettings(...args);
  const articlePage = useArticlePageSettings(...args);
  const articlePublisher = useArticlePublisherSettings(...args);
  const askMeAnythingEventCreationPage = useAskMeAnythingEventCreationPageSettings(...args);
  const askMeAnythingEventEditingPage = useAskMeAnythingEventEditingPageSettings(...args);
  const campaignsDashboardPage = useCampaignsDashboardPageSettings(...args);
  const complianceDataAdminPage = useComplianceDataAdminPageSettings(...args);
  const configureTenantAdminPage = useConfigureTenantAdminPageSettings(...args);
  const discoverGroupsPage = useDiscoverGroupsPageSettings(...args);
  const draftPost = useDraftPostSettings(...args);
  const homeFeedPage = useHomeFeedPageSettings(...args);
  const inboxPage = useInboxPageSettings(...args);
  const insightsAdminPage = useInsightsAdminPageSettings(...args);
  const insightsCampaignPage = useInsightsCampaignPageSettings(...args);
  const insightsLeadersMyInsightsPage = useInsightsLeadersMyInsightsPageSettings(...args);
  const insightsLeadersOrgPage = useInsightsLeadersOrgPageSettings(...args);
  const insightsNavigation = useInsightsNavigationSettings(...args);
  const insightsNetworkPage = useInsightsNetworkPageSettings(...args);
  const insightsQnAMyInsightsPage = useInsightsQnAMyInsightsPageSettings(...args);
  const insightsQnAOrgPage = useInsightsQnAOrgPageSettings(...args);
  const leadersAdminPage = useLeadersAdminPageSettings(...args);
  const leadershipCornerAdminPage = useLeadershipCornerAdminPageSettings(...args);
  const navigation = useNavigationSettings(...args);
  const networkAdminPage = useNetworkAdminPageSettings(...args);
  const questionsAdminPage = useQuestionsAdminPageSettings(...args);
  const storylineAdminPage = useStorylineAdminPageSettings(...args);
  const threadPage = useThreadPageSettings(...args);
  const userRolesAdminPage = useUserRolesAdminPageSettings(...args);

  return useStrictFeatureSettings({
    achievementsAdminPage,
    articlePage,
    articlePublisher,
    askMeAnythingEventCreationPage,
    askMeAnythingEventEditingPage,
    campaignsDashboardPage,
    complianceDataAdminPage,
    configureTenantAdminPage,
    discoverGroupsPage,
    draftPost,
    homeFeedPage,
    inboxPage,
    insightsAdminPage,
    insightsCampaignPage,
    insightsLeadersMyInsightsPage,
    insightsLeadersOrgPage,
    insightsNavigation,
    insightsNetworkPage,
    insightsQnAMyInsightsPage,
    insightsQnAOrgPage,
    leadersAdminPage,
    leadershipCornerAdminPage,
    navigation,
    networkAdminPage,
    questionsAdminPage,
    storylineAdminPage,
    threadPage,
    userRolesAdminPage,
  });
};
